export default __webpack_public_path__ + "static/media/0m.d9220ca3.png";